import type {
  ParentAssignResult,
  ParentUnassignResult,
} from '~/hooks/mutations/useParentChildReportTemplateAssignMutations';
import type {
  AssignResult,
  UnassignResult,
} from '~/hooks/mutations/useStaffClientReportTemplateAssignMutations';

type BulkResult = AssignResult | UnassignResult | ParentAssignResult | ParentUnassignResult;

export function summarizeBulkTemplateResults(
  results: BulkResult[],
  action: 'assign' | 'unassign',
): string {
  const successKey = action === 'assign' ? 'assigned' : 'unassigned';
  const success = results.filter((r) => r.status === successKey).length;
  const skipped = results.filter((r) => r.status === 'skipped').length;
  const failed = results.filter((r) => r.status === 'failed').length;

  const parts: string[] = [];
  if (success > 0) {
    parts.push(`${success} ${successKey}`);
  }
  if (skipped > 0) {
    parts.push(`${skipped} skipped (already assigned)`);
  }
  if (failed > 0) {
    parts.push(`${failed} failed`);
  }

  return parts.length > 0 ? parts.join(', ') : 'No changes made';
}

export function getBulkTemplateFailureMessages(results: BulkResult[]): string[] {
  return results
    .filter((r) => r.status === 'failed')
    .map((r) => {
      if (r.message) return r.message;
      if ('code' in r && r.code === 'WRONG_REPORTING_MODE') {
        return 'Wrong stat set for this client.';
      }
      return 'Assign failed';
    });
}
